const eaRest = document.querySelector('meta[name="ea_rest"]').content;
const eaTheme = document.querySelector('meta[name="ea_theme_build"]').content;
const eaCsrf = document.querySelector('meta[name="ea_csrf"]') || '';
export {eaRest, eaTheme, eaCsrf};
